const validatePhone = (rule, value, callback) => {
  if (value) {
    if (!/^1[3456789]\d{9}$/.test(value)) {
      callback(new Error('请输入正确的手机号码'))
    } else {
      callback()
    }
  }
}

export function declareProjectConfig(changeColumn) {
  return {
    labelWidth: 160,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: '项目编号',
        formslot: true,
        prop: 'number',
        span: 12
      }, {
        label: '项目名称',
        prop: 'projectName',
        placeholder: '请输入项目名称',
        span: 12,
        rules: [
          {
            required: true,
            message: '请输入项目名称',
            trigger: 'blur'
          }
        ]
      }, {
        label: '项目类型',
        prop: 'projectType',
        type: 'select',
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zs_project_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: "string",
        change: ({ value, column}) => {
          // 若value== 4，则显示人才类型
            changeColumn(value)
        },
        span: 12,
        rules: [
          {
            required: true,
            message: '请选择项目类型',
            trigger: 'change'
          }
        ]
      }, {
        label: '人才类型',
        prop: 'talentType',
        type: 'select',
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zs_talent_type',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: "string",
        display: false,
        span: 12,
        rules: [
          {
            required: true,
            message: '请选择人才类型',
            trigger: 'change'
          }
        ]
      },{
        label: '投资规模',
        prop: 'investScale',
        append: '亿元',
        display: true,
        span: 12,
        rules: [
          {
            required: true,
            message: '请输入投资规模',
            trigger: 'blur'
          }
        ]
      }, {
        label: '投资方',
        prop: 'investor',
        span: 12,
        rules: [
          {
            required: true,
            message: '请输入投资方',
            trigger: 'blur'
          } 
        ]
      }, {
        label: '建议落地',
        prop: 'projectLanding',
        type: 'select',
        span: 12,
        dicUrl: '/api/blade-system/dict-biz/dictionary?code=zs_landing_area',
        props: {
          label: "dictValue",
          value: "dictKey"
        },
        dataType: "string",
        rules: [
          {
            required: true,
            message: '请输入建议落地',
            trigger: 'blur'
          } 
        ]
      }, {
        label: '对接联系人',
        prop: 'contactPersonList',
        formslot: true,
        span: 12,
        rules: [
          {
            required: true,
            message: '请输入对接联系人',
          }
        ]
      }, {
        label: '项目概览',
        prop: 'projectOverview',
        span: 24,
        type: 'textarea',
        minRows: 4,
        rules: [
          {
            required: true,
            message: '请输入项目概览',
            trigger: 'blur'
          }
        ]
      }, {
        label: '项目诉求',
        prop: 'projectDemands',
        span: 24,
        type: 'textarea',
        minRows: 4,
        rules: [
          {
            required: true,
            message: '请输入项目诉求',
            trigger: 'blur'
          }
        ]
      }, {
        label: '对接情况',
        prop: 'contactSituation',
        span: 24,
        type: 'textarea',
        minRows: 4,
        rules: [
          {
            required: true,
            message: '请输入对接情况',
            trigger: 'blur'
          }
        ]
      }, {
        label: '补充内容',
        prop: 'additionalContent',
        span: 24,
        type: 'textarea',
        minRows: 4
      }

    ]
  }
}

export function adviceConfig() {
  return {
    labelWidth: 160,
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: '您的意见建议',
        prop: 'advice',
        span: 24,
        type: 'textarea',
        minRows: 4,
        rules: [
          {
            required: true,
            message: '请输入您的意见建议',
            trigger: 'blur'
          }
        ]
      }
    ]
  }
}
export function addPersonFormConfig() {
  return {
    emptyBtn: false,
    submitBtn: false,
    column: [
      {
        label: '姓名',
        prop: 'name',
        span: 24,
        rules: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          } 
        ]
      }, {
        label: '联系电话',
        prop: 'phone',
        span: 24,
        rules: [
          {
            required: true,
            // message: '请输入联系电话',
            validator: validatePhone,
            trigger: 'blur'
          } 
        ]
      }, {
        label: '职务',
        prop: 'job',
        span: 24,
        rules: [
          {
            required: true,
            message: '请输入职务',
            trigger: 'blur'
          } 
        ]
      }
    ]
  }
}